import React, { FC } from 'react';
import { WdsFontPicker } from '@wix/tpa-settings/react';
import { IWixStyleFont } from '@wix/tpa-settings';
import { useTranslation } from '../../../../utils/flow';
import { useStyles } from '../../../../utils/useStyles';
import stylesParams from '../../../../../stylesParams';

export const TITLE_DEFAULT_TAG = 'h3';

export const Titles: FC = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const font = styles.get(stylesParams.titleFont);
  const useOptimalFontSizes = styles.get(stylesParams.useOptimalFontSizes);

  return (
    <WdsFontPicker
      dataHook="titles"
      value={{
        font,
        htmlTag: font?.htmlTag || TITLE_DEFAULT_TAG,
      }}
      fontPickerOptions={{
        showHTMLTag: true,
        hideSize: useOptimalFontSizes,
      }}
      onFontChange={(value: IWixStyleFont) =>
        styles.set(stylesParams.titleFont, value)
      }
      title={t('app-settings.design.text.titles.label')}
      panelTitle={t('app-settings.design.titles')}
    />
  );
};
